<script lang="ts">
    import { createEventDispatcher, onMount } from 'svelte'
    import LoginGoogle from '../../_common/login-google.svelte'
    import LoadSpinner from '../../_common/load-spinner.svelte'
    import type { Channel } from '../../../modules/brokerApi/channels/channel'

    const dispatch = createEventDispatcher()

    export let channelId: string

    // mesmo client id já usado na integração com o Google Agenda (mesmo projeto no Google Cloud)
    const CLIENT_ID = '482161957283-a7efraa0t6gbhteqslj5qgs3k3o0481f.apps.googleusercontent.com'
    // gmail.send permite apenas enviar. userinfo.email é o que nos deixa saber e exibir a conta conectada.
    const SCOPES = ['https://www.googleapis.com/auth/gmail.send', 'https://www.googleapis.com/auth/userinfo.email']

    let show = false
    let channel: Channel = null
    let connectedEmail: string = null

    async function load() {
        try {
            show = true
            channel = await window.api.brokers.channels.getOne(channelId)
            connectedEmail = channel?.credentials?.googleEmail || channel?.externalName || null
        } catch (error) {
            window.error(error)
        } finally {
            show = false
        }
    }

    async function onAuthSuccess(ev) {
        try {
            show = true
            const result = await window.api.brokers.channels.gmailToken(channelId, ev.detail.code, ev.detail.redirctUri)
            connectedEmail = result?.email || null
            dispatch('connected')
        } catch (error) {
            window.error(error)
        } finally {
            show = false
        }
    }

    function onAuthInfo(ev) {
        // o usuário fechou o popup ou negou o consentimento
        const error = ev.detail?.response?.error
        if (error && error !== 'popup_closed' && error !== 'access_denied') {
            window.error('Não foi possível concluir a conexão com o Google: ' + error)
        }
    }

    onMount(async () => {
        await load()
    })
</script>

<LoadSpinner {show}></LoadSpinner>

<div class="config-box m-4">
    <div class="d-flex flex-column align-items-center">
        {#if connectedEmail}
            <div class="subtitle mb-2">Conta conectada</div>
            <div class="account mb-4">{connectedEmail}</div>
            <div class="text-muted text-center mb-3">
                Para trocar a conta usada nos envios, entre novamente com o Google.
            </div>
        {:else}
            <div class="subtitle mb-4">Entre com sua conta Google para enviar e-mails por ela</div>
        {/if}

        <LoginGoogle clientId={CLIENT_ID} scopes={SCOPES} on:auth-success={onAuthSuccess} on:auth-info={onAuthInfo} />

        <div class="text-muted text-center mt-4">
            O Zandu receberá permissão apenas para <strong>enviar</strong> e-mails em seu nome.<br />
            Não temos acesso para ler sua caixa de entrada.
        </div>

        <div class="alert alert-secondary mt-4 text-center">
            Sua conta Google tem um limite diário de envios (cerca de 500 por dia em contas gratuitas e 2.000 em contas
            Workspace).<br />
            Configure o "Limite de envio diário" do provedor de acordo com sua conta.<br />
            Este canal também não recebe confirmação de entrega: e-mails devolvidos chegam na sua própria caixa.
        </div>
    </div>
</div>

<style>
    .subtitle {
        font-size: 15px;
    }
    .account {
        font-weight: 600;
        font-size: 16px;
    }
</style>
